import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

export default function Error404() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-16 text-center sm:px-6 lg:px-8 animate-in fade-in duration-500">
      <Helmet>
        <title>Siden blev ikke fundet (404) | Bachmann Tømrer</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div className="max-w-md">
        {/* Decorative Icon */}
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-brand-brown/10 text-brand-brown mb-8">
          <i className="fa-solid fa-compass-slash text-4xl" />
        </div>

        <span className="text-xs font-bold uppercase tracking-widest text-brand-brown">Fejl 404</span>
        <h1 className="font-serif text-3xl sm:text-4xl font-bold text-brand-graphite mt-2 mb-4">
          Siden blev ikke fundet
        </h1>
        <p className="text-xs sm:text-sm text-brand-graphite/70 mb-8 leading-relaxed">
          Beklager, men den side du leder efter findes ikke, er blevet slettet eller har fået ny adresse. Brug menuen eller knapperne herunder til at finde vej igen.
        </p>

        {/* Navigation Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="w-full sm:w-auto rounded-full bg-brand-brown px-6 py-3 text-xs font-bold uppercase tracking-wider text-white shadow-md transition-all duration-300 hover:bg-brand-brown-dark hover:shadow-lg"
          >
            <i className="fa-solid fa-house mr-1.5" /> Gå til forsiden
          </Link>
          <Link
            to="/kontakt"
            className="w-full sm:w-auto rounded-full border border-brand-brown/30 bg-white px-6 py-3 text-xs font-bold uppercase tracking-wider text-brand-brown hover:bg-brand-beige"
          >
            Kontakt os
          </Link>
        </div>

        {/* Helpful Links */}
        <div className="mt-12 border-t border-brand-brown/10 pt-8">
          <h3 className="font-serif text-xs font-bold uppercase tracking-wider text-brand-graphite/60 mb-4">
            Populære sider
          </h3>
          <div className="flex flex-wrap justify-center gap-4 text-xs">
            <Link to="/vinduer-og-doere" className="text-brand-graphite/80 hover:text-brand-brown hover:underline">
              Vinduer & døre
            </Link>
            <span className="text-brand-brown/30">•</span>
            <Link to="/tagarbejde-2" className="text-brand-graphite/80 hover:text-brand-brown hover:underline">
              Tagarbejde
            </Link>
            <span className="text-brand-brown/30">•</span>
            <Link to="/terrasser" className="text-brand-graphite/80 hover:text-brand-brown hover:underline">
              Træterrasser
            </Link>
            <span className="text-brand-brown/30">•</span>
            <Link to="/galleri" className="text-brand-graphite/80 hover:text-brand-brown hover:underline">
              Galleri
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
